"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFixed = void 0;

const toFixed = (n, fixed) => ~~(10 ** fixed * n) / 10 ** fixed;

exports.toFixed = toFixed;